import React, {useContext, useEffect} from 'react'
import { SectionContext } from "../context/sectionContext"
import { PageContext } from "../context/pageContext"
import { ConditionContext } from "../context/conditionContext"
import { JourneyContext } from "../context/journeyContext"
import { ErrorContext } from "../context/errorContext"
import { getValueFromJourney } from '../services/helperFunctions'
import { lineCapital } from '../../shared/functions'
import { generateBI, fetchApplicationDetails, saveApplication } from "../../services/apiservice"

export default function ComponentButton(props) {
    const [sectionState, setSectionState] = useContext(SectionContext)
    const [pageState, setPageState] = useContext(PageContext)
    const [conditionState, setConditionState] = useContext(ConditionContext)
    const [journeyState, setJourneyState] = useContext(JourneyContext)
    const [errorState, setErrorState] = useContext(ErrorContext)

    useEffect(() => {
        if(journeyState.journeyIdFromStrapi === "FlexiEdgeJourney"
        && !sectionState.sectionData?.["sumAssured"]){
            props.setShowMainButtonFlexiEdgePlan(false)
        }
    }, [])
    
    const calculateGSP = () => {
        let isValidSection = Object.keys(errorState).every(element => {
            if (Array.isArray(errorState[element])) {
              return errorState[element].every(subElement => {
                return subElement === ""
              })
            } else {
              return errorState[element] === ""
            }
        })
        setJourneyState(prev => {
            return {
              ...prev,
              premium: sectionState.sectionData["premiumAmount"],
            }
          })
        if(isValidSection){
            if (pageState.pageId === props.pages[props.currentPageIndex].pageId) {
                let foundSection = pageState.pageData.find(
                    element => element.sectionId === sectionState.sectionId
                )
            
                if (foundSection) {
                    let newPageData = pageState.pageData.filter(
                        element => element.sectionId !== foundSection.sectionId
                    )
                    setPageState(prev => {
                        return {
                            ...prev,
                            pageData: newPageData, //newPageData has all sections except founded section
                        }
                    })
                    foundSection = {}
                }
        
                setPageState(prev => {
                    return {
                        ...prev,
                        pageData: [...prev.pageData, sectionState], // adding new section
                    }
                })
            } else {
                setPageState(prev => {
                    return {
                        ...prev,
                        pageId: props.pages[props.currentPageIndex].pageId,
                        pageData: [...prev.pageData, sectionState],
                    }
                })
            }
            
            let pageData = pageState.pageData.filter(
                element => element.sectionId !== sectionState.sectionId
            )
            let journeyData = journeyState.journeyData.filter(
                element => element.pageId !== props.pages[props.currentPageIndex].pageId
            )
        
            let LoadPaylod = [
            ...journeyData,
            {
                pageId: props.pages[props.currentPageIndex].pageId,
                pageData: [...pageData, sectionState],
            },
            ]
        
            let sendPayload = {
            applicationData: LoadPaylod,
            journeyData: {
                _id: journeyState.journeyId,
                lastPage: props.currentPageIndex,
                lastSection: props.currentSectionIndex,
                applicationNo: journeyState.applicationNo,
                illustrationNumber: journeyState.illustrationNumber,
                planOption : journeyState.planOption,
                journeyIdFromStrapi: journeyState.journeyIdFromStrapi,
                proposalEntryId: journeyState.proposalEntryId,
                lastPageCode: props.pageId,
                premium: journeyState.premium,
                lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
            },
            }
            saveApplication(sendPayload).then(async res => {
                let payload = {
                    journeyId: journeyState.journeyId,
                }
                const biApiData = await generateBI(payload)
                if(biApiData.data?.BIJson){
                    let biJson = JSON.parse(biApiData.data?.BIJson)
                    let sumAssured = Math.floor(biJson[0]?.["SA"])
                    let gspAddition = Math.floor(biJson[0]?.["GUAR_ADDITIONS"])
                    let total = Math.floor(sumAssured + gspAddition)
                    setConditionState((prev) => {
                        return ({
                            ...prev,
                            [`${props.pageId}.${props.sectionId}.showGSPBanner`]: "show"
                        })
                    })
                    setSectionState((prev) => {
                        return ({
                            ...prev,
                            sectionData: {
                            ...prev.sectionData,
                            ["sumAssured"]: sumAssured,
                            ["GspAddition"]: gspAddition,
                            ["totalAmount"]: total
                            },
                        })
                    })
                }
            }).catch(err => {
                console.log(err, "err in saveApplication componentButton")
            })
        }
        
        
    }

    const calculateFlexiEdge = () => {
        let isValidSection = Object.keys(errorState).every(element => {
            if (Array.isArray(errorState[element])) {
              return errorState[element].every(subElement => {
                return subElement === ""
              })
            } else {
              return errorState[element] === ""
            }
        })
        setJourneyState(prev => {
            return {
              ...prev,
              premium: sectionState.sectionData["FlexiInstallmentPremium"],
            }
          })
        if(isValidSection){
            if (pageState.pageId === props.pages[props.currentPageIndex].pageId) {
                let foundSection = pageState.pageData.find(
                    element => element.sectionId === sectionState.sectionId
                )
            
                if (foundSection) {
                    let newPageData = pageState.pageData.filter(
                        element => element.sectionId !== foundSection.sectionId
                    )
                    setPageState(prev => {
                        return {
                            ...prev,
                            pageData: newPageData, //newPageData has all sections except founded section
                        }
                    })
                    foundSection = {}
                }
        
                setPageState(prev => {
                    return {
                        ...prev,
                        pageData: [...prev.pageData, sectionState], // adding new section
                    }
                })
            } else {
                setPageState(prev => {
                    return {
                        ...prev,
                        pageId: props.pages[props.currentPageIndex].pageId,
                        pageData: [...prev.pageData, sectionState],
                    }
                })
            }
            
            let pageData = pageState.pageData.filter(
                element => element.sectionId !== sectionState.sectionId
            )
            let journeyData = journeyState.journeyData.filter(
                element => element.pageId !== props.pages[props.currentPageIndex].pageId
            )
        
            let LoadPaylod = [
            ...journeyData,
            {
                pageId: props.pages[props.currentPageIndex].pageId,
                pageData: [...pageData, sectionState],
            },
            ]
        
            let sendPayload = {
            applicationData: LoadPaylod,
            journeyData: {
                _id: journeyState.journeyId,
                lastPage: props.currentPageIndex,
                lastSection: props.currentSectionIndex,
                applicationNo: journeyState.applicationNo,
                illustrationNumber: journeyState.illustrationNumber,
                planOption : journeyState.planOption,
                journeyIdFromStrapi: journeyState.journeyIdFromStrapi,
                proposalEntryId: journeyState.proposalEntryId,
                lastPageCode: props.pageId,
                premium: journeyState.premium,
                lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
            },
            }
            saveApplication(sendPayload).then(async res => {
                let payload = {
                    journeyId: journeyState.journeyId,
                }
                const biApiData = await generateBI(payload)
                if(biApiData.data?.BIJson){
                    let biJson = JSON.parse(biApiData.data?.BIJson)
                    let sumAssured = Math.floor(biJson[0]?.["SA"])

                    let temp = journeyState.journeySteps
                    const tempComponentGroupIndexToChange = temp.pages[0].sections[2].component_groups.findIndex(element => element.componentId === "flexiEdgeCalculateButton")
                    const tempComponentIndex = temp.pages[0].sections[2].component_groups[tempComponentGroupIndexToChange].components.findIndex(element => element.formControlKey === "flexiEdgeCalculateButton")
                    temp.pages[0].sections[2].component_groups[tempComponentGroupIndexToChange].components[tempComponentIndex]["display"] = false;
                    setJourneyState(prev => {
                        return ({
                            ...prev,
                            journeySteps: temp
                        })
                    })
                    setConditionState((prev) => {
                        return ({
                            ...prev,
                            [`${props.pageId}.${props.sectionId}.showFlexiEdgeBanner`]: "show"
                        })
                    })
                    props.setShowMainButtonFlexiEdgePlan(true)
                    setSectionState((prev) => {
                        return ({
                            ...prev,
                            sectionData: {
                                ...prev.sectionData,
                                ["sumAssured"]: sumAssured,
                            },
                        })
                    })
                }
            }).catch(err => {
                console.log(err, "err in saveApplication componentButton")
            })
        }else{
            props.setShowError(true)
        }
        
        
    }

    const checkFunctionToCall = (ev, functionName) => {
        ev.preventDefault()
        if(functionName === "calculateGSP"){
            calculateGSP()
        }else if(functionName === "calculateFlexiEdge"){
            calculateFlexiEdge()
        }
    }

    console.log(props.data.Alignment, sectionState);
    let align = "flex-start";
    if(props.data.Alignment === 'Right')
    {
        align ="flex-end"
    }
    else if(props.data.Alignment === 'Center')
    {
        align ="center"
    }
    return (
        
        <>
        <style>
        {`
            @media (min-width: 768px){
                .pd-mobile-space-structure{
                    display:none !important;
                }
            }

        `}
        </style>
            {/* <div dangerouslySetInnerHTML={{ "__html": props.data.Content }}></div> */}
            <div  style ={{
                display:"flex",
                justifyContent: align
            }}
            className="hidden-desktop-screen">
                <button className="previous-btn cen"
                type="submit" htmlFor={props.data.label} 
                onClick={(ev) => checkFunctionToCall(ev,props.data.functionToCall)}
                style={{
                    color: "white",
                    padding: "14px 40px",
                    border: "none",
                }}
               >{(getValueFromJourney(
                journeyState.lookup.label,
                props.data.label
              )) || props.data.label}</button>
            </div>
            <div  style ={{
                display:"flex",
                justifyContent: align
            }}
            className="mobile-view-btn-Q1 pd-mobile-space-structure button1">
                <button className="previous-btn cen"
                type="submit" htmlFor={props.data.label} 
                onClick={(ev) => checkFunctionToCall(ev,props.data.functionToCall)}
                style={{
                    color: "white",
                    padding: "14px 40px",
                    border: "none",
                }}
                >{(getValueFromJourney(
                    journeyState.lookup.label,
                    props.data.label
                )) || props.data.label}</button>
            </div>
        </>
    )
    
}